import { Route, Routes } from "react-router-dom";
import Login from "./pages/Login";
import Projects from "./pages/Projects";
import ProjectManagement from "./pages/ProjectManagement";
import UserManagement from "./pages/UserManagement";
import { Toaster } from "react-hot-toast";
import TdViewer from "./pages/TdViewer";
import FdViewer from "./pages/FdViewer";
import Dashboard from "./pages/Dashboard";
import Lineup from "./pages/Lineup";

function App() {
  return (
    <>
      <Toaster />
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/projects" element={<Projects />} />
        <Route path="/project-management" element={<ProjectManagement />} />
        <Route path="/user-management" element={<UserManagement />} />
        <Route path="/3d-viewer" element={<TdViewer />} />
        <Route path="/4d-viewer" element={<FdViewer />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/line-up" element={<Lineup />} />
      </Routes>
    </>
  );
}

export default App;
